export enum AuthSettingName {
  EMAIL = "EMAIL",
  YANDEX_ID = "YANDEX_ID",
  LOGIN = "LOGIN",
  VK_ID = "VK_ID",
  TELEGRAM = "TELEGRAM",
}

export enum CandidateSearchType {
  EMAIL = "email",
  YANDEX_ID = "yandexEmail",
  LOGIN = "login",
  VK_ID = "vkId",
  TELEGRAM = "telegramUsername",
  FULL_NAME = "fullName",
  NUMERIC_ID = "numericId",
}

// TODO: переименовать
export const AUTH_SETTING_OPTIONS = [
  { label: "ФИО", value: CandidateSearchType.FULL_NAME },
  { label: "ID пользователя", value: CandidateSearchType.NUMERIC_ID },
  { label: "Email", value: CandidateSearchType.EMAIL },
  { label: "Yandex ID", value: CandidateSearchType.YANDEX_ID },
  { label: "Логин", value: CandidateSearchType.LOGIN },
  { label: "VK ID", value: CandidateSearchType.VK_ID },
  { label: "Telegram", value: CandidateSearchType.TELEGRAM },
];
